import { ICellRendererParams } from "ag-grid-community";

export function MessageOpenedRenderer(params: ICellRendererParams): string
{
	if (!params.data.isPaid)
	{
		return "<i class=\"fa-solid fa-lock\"></i>";
	}
	else if (params.data.openedSecondsFromEpoch !== 0 && params.data.openedSecondsFromEpoch !== null)
	{
		return "<i class=\"fa-light fa-envelope-open\"></i>";
	}
	else
	{
		return "<i class=\"fa-light fa-envelope\"></i>";
	}
}
